import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import { SocketContext } from "../../context/SocketContext";
import { MediaContext } from "../../context/MediaContext";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { SButton } from "../BasicComponents";
import { SNotes, SNoteList, SNote, STextEditor } from "./Notes.styles";

/* Box containing the chat with the list of chat messages and a form to insert a new question or a new normal message. */
const Notes = () => {
  const { notes } = useContext(SocketContext);
  const { t } = useTranslation("", { keyPrefix: "components.notes" });

  const [showEditor, setShowEditor] = useState(false);

  return (
    <SNotes>
      <SButton onClick={() => setShowEditor(!showEditor)}>{`${
        showEditor ? t("show_notes") : t("create_note")
      }`}</SButton>

      {showEditor ? (
        <TextEditor setShowEditor={setShowEditor} />
      ) : (
        <SNoteList>
          {notes.map((note) => (
            <Note key={note.uuid} note={note} />
          ))}
        </SNoteList>
      )}
    </SNotes>
  );
};

const Note = ({ note }) => {
  const { player } = useContext(MediaContext);

  return (
    <SNote>
      <div className="d-flex flex-row justify-content-between align-items-center">
        <span className="name">
          {note.user.firstName} {note.user.lastName}
        </span>
        <div className="d-flex flex-row">
          {note.slideNumber !== null && note.slideNumber > 0 && <i className="fas fa-file-pdf mx-2" />}
          {note.videoTs !== null && <i className="fas fa-video mx-2" onClick={() => player.seekTo(note.videoTs)} />}
        </div>
      </div>
      <div className="fs-5">{parse(note.text)}</div>
    </SNote>
  );
};

const TextEditor = ({ setShowEditor }) => {
  const { t } = useTranslation("", { keyPrefix: "components.notes" });

  const { sendSocketEvent } = useContext(SocketContext);
  const { getVideoTs, slideNumber } = useContext(MediaContext);

  const [note, setNote] = useState("");

  const config = {
    height: "500px",
  };

  const onSend = (e) => {
    e.preventDefault();

    if (note.length > 0) {
      sendSocketEvent("notes/note", {
        text: note,
        videoTs: getVideoTs(),
        slideNumber: slideNumber,
        isPrivate: true,
      });

      setNote("");
      setShowEditor(false);
    }
  };

  return (
    <STextEditor>
      <CKEditor
        editor={ClassicEditor}
        config={config}
        data={note}
        onChange={(event, editor) => {
          const data = editor.getData();
          setNote(data);
        }}
      />
      <div className="btn-section">
        <SButton onClick={onSend}>{t("post")}</SButton>
      </div>
    </STextEditor>
  );
};

export default Notes;
